import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderFinancingBrokerageDataSchema } from './ServicesProviderFinancingBrokerageData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderFinancingBrokerage extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderFinancingBrokerageDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderFinancingBrokerage.validation', `ServicesProviderFinancingBrokerage data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.FINANCING_BROKERAGE,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.FINANCING_BROKERAGE, ServicesProviderFinancingBrokerage);

export { ServicesProviderFinancingBrokerage };
//# sourceMappingURL=ServicesProviderFinancingBrokerage.js.map
